import {calculateStrokeDashoffset} from "common/hook/calcul";

export const RadialStatCol = ({ colTitle, percentValue }: { colTitle: string; percentValue: number | null }) => {
    const gradientId = `linearColors-${colTitle}`;

    return (
        <div className="col radial-stat-col">
            <span className="col-title">{colTitle}</span>
            {percentValue !== null ? (
                <div className="radial-statistic small">
                    <span className="percents">{percentValue}%</span>
                    <svg width="60" height="60" className="radial-progress">
                        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0%" stopColor="rgba(193, 232, 111, 1)"></stop>
                            <stop offset="50%" stopColor="rgba(239, 231, 45, 1)"></stop>
                            <stop offset="100%" stopColor="rgba(255, 110, 109, 1)"></stop>
                        </linearGradient>
                        <circle
                            r="24"
                            cx="26"
                            cy="26"
                            className="external-circle"
                            strokeWidth="4"
                            fill="#fff"
                            stroke={`url(#${gradientId})`}
                            strokeDashoffset={calculateStrokeDashoffset(percentValue)}
                        />
                    </svg>
                </div>
            ) : (
                <div className="col radial-stat-col col-none">
                    <span className="percents"></span>
                    <svg width="60" height="60" className="radial-progress"></svg>
                </div>
            )}
        </div>
    );
};
